import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND } from '../../config/brand';

interface BrandLogoProps {
  height?: number;
  showText?: boolean;
  variant?: 'light' | 'dark';
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  height = 48,
  showText = true,
  variant = 'dark',
}) => {
  const textColor = variant === 'light' ? BRAND.colors.white : BRAND.colors.navy;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box
        component="img"
        src={BRAND.images.logo}
        alt={`${BRAND.name} ${BRAND.subtitle}`}
        sx={{
          height,
          width: 'auto',
          objectFit: 'contain',
          filter: variant === 'light' ? 'brightness(1.1)' : 'none',
        }}
      />
      {showText && (
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 800,
              lineHeight: 1.1,
              color: textColor,
              letterSpacing: '0.04em',
              fontSize: '0.95rem',
            }}
          >
            {BRAND.name.toUpperCase()}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: variant === 'light' ? 'rgba(255,255,255,0.85)' : BRAND.colors.navyLight,
              fontStyle: 'italic',
              fontSize: '0.7rem',
            }}
          >
            {BRAND.tagline}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default BrandLogo;
